import { motion } from "framer-motion";
import { Gauge } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { FormData, tempoOptions } from "../types";

interface TempoStepProps {
  formData: FormData;
  onChange: (field: keyof FormData, value: string) => void;
}

const TempoStep = ({ formData, onChange }: TempoStepProps) => {
  return (
    <motion.div
      key="tempo"
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      className="space-y-6"
    >
      <div className="text-center mb-8">
        <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
          <Gauge className="w-8 h-8 text-primary" />
        </div>
        <h2 className="font-heading text-2xl font-bold text-foreground mb-2">
          Tempo and Speed
        </h2>
        <p className="text-muted-foreground">
          How fast or slow should your song be?
        </p>
      </div>

      <div className="space-y-4">
        <Label>Select one *</Label>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {tempoOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange("tempo", option.value)}
              className={`p-4 rounded-xl border-2 transition-all text-center ${
                formData.tempo === option.value
                  ? "border-primary bg-primary/5"
                  : "border-border hover:border-primary/50"
              }`}
            >
              <span className="font-medium">{option.label}</span>
            </button>
          ))}
        </div>
      </div>

      {formData.tempo === "other" && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          className="space-y-2"
        >
          <Label htmlFor="tempoOther">Describe the tempo *</Label>
          <Input
            id="tempoOther"
            placeholder="Describe your preferred tempo"
            value={formData.tempoOther}
            onChange={(e) => onChange("tempoOther", e.target.value)}
          />
        </motion.div>
      )}
    </motion.div>
  );
};

export default TempoStep;
